import React, {useState, useEffect} from 'react'
import { currentLang } from '../../../utils/functions'
import { Link } from 'react-router-dom';

const images2_nl_folder = "https://www.grutto.com/storage/NL/farmshop/banners/";
const images2_de_folder = "https://www.kaufnekuh.de/storage/DE/farmshop/banners/";

function BrandBanner({bannerId, isMobile, lang}) {
  const slugs = {
    "nl": [
      {
        "imgName": "natuurlijke-processen",
        "url": "natuurlijke-processen"
      },
      {
        "imgName": "onze-vleespakketten-1",
        "url": "onze-vleespakketten"
      },
      {
        "imgName": "kop-tot-staart",
        "url": "kop-tot-staart"
      },
      {
        "imgName": "scharrelkippen",
        "url": "scharrelkippen"
      },
      {
        "imgName": "weidevarkens",
        "url": "weidevarkens"
      },
      {
        "imgName": "lokaal-lamsvlees-van-nederlandse-boeren",
        "url": "lokaal-lamsvlees-van-nederlandse-boeren"
      },
      {
        "imgName": "duurzaam-gevangen-vis-door-kleinschalige-visserijen",
        "url": "duurzaam-gevangen-vis-door-kleinschalige-visserijen"
      },
      {
        "imgName": "nederlandse-natuurgebieden",
        "url": "nederlandse-natuurgebieden"
      }
    ],
    "de": [
      {
        "imgName": "tierschutz",
        "url": "tierschutz"
      },
      {
        "imgName": "unsere-fleischpakete",
        "url": "unsere-fleischpakete"
      },
      {
        "imgName": "versand",
        "url": "versand"
      },
      {
        "imgName": "schwanz-bis-schnauze",
        "url": "schwanz-bis-schnauze"
      },
      {
        "imgName": "unsere-huhner-laufen-frei-herum",
        "url": "unsere-huhner-laufen-frei-herum"
      },
      {
        "imgName": "unsere-schweine-konnen-immer-an-die-frische-luft",
        "url": "unsere-schweine-konnen-immer-an-die-frische-luft"
      }
    ],
  }

  var slug = slugs[currentLang()][bannerId];
  var image2_url = images2_nl_folder + slug.imgName + '-' + (isMobile ? 'mobile' : 'desktop') + '.jpg';
  var image4_url = images2_de_folder + slug.imgName + '-' + (isMobile ? 'mobile' : 'desktop') + '.jpg';

  return (
    <>
      {currentLang() == "nl" &&
        <div className={'banner-holder id-' + bannerId}>
          <div className='banner-link'>
            <Link to={"/"+currentLang()+"/" + slug.url}>
              <img src={image2_url} />
            </Link>
          </div>
        </div>
      }
      {currentLang() == "de" &&
        <div className={'banner-holder id-' + bannerId}>
          <div className='banner-link'>
            <Link to={"/"+currentLang()+"/" + slug.url}>
              <img src={image4_url} />
            </Link>
          </div>
        </div>
      }
    </>
  )
}

export default BrandBanner